import { useEffect, useState } from 'react';
import { getConsent, setConsent } from './consent.js';
import { CONSENT_EVENT, type CookieConsent } from './types.js';

export function useConsent() {
  const [consent, setConsentState] = useState<CookieConsent | null>(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setConsentState(getConsent());
    setIsLoaded(true);

    const handler = (event: Event) => {
      const custom = event as CustomEvent<CookieConsent>;
      if (custom.detail) {
        setConsentState(custom.detail);
      } else {
        setConsentState(getConsent());
      }
    };

    window.addEventListener(CONSENT_EVENT, handler);
    return () => window.removeEventListener(CONSENT_EVENT, handler);
  }, []);

  return {
    consent,
    isLoaded,
    accept: () => setConsent(true),
    reject: () => setConsent(false),
    showBanner: isLoaded && consent === null,
  };
}
